module.exports = __webpack_public_path__ + "static/your-stylist-result-3-19e44511ef135a869e2ee8709946814b.png";